define('views/modules/setting/business/list/membership-plan-list',[
    // Libs
    'underscore', 'backbone',
    // views
    'views/parts/list/list',
    'views/modules/setting/business/list/membership-plan-list-item'
], function(
    // Libs
    _, Backbone,
    // views
    VList,
    VMembershipPlanListItem
) {

    var VMembershiptPlanList = VList.extend({
        item: VMembershipPlanListItem,
        initialize: function(options) {
            this.options = options || {};
        },

        render: function() {
            this.constructor.__super__.render.apply(this, {});

            this.zone.$list.toggleClass('list-3-by-3', this.collection.length % 3 === 0);
        },

        updateItemOptions: function(itemOptions) {
            this.options.itemOptions.selectedPlan = itemOptions.selectedPlan;
            this.options.itemOptions.teamPaymentCurrency = itemOptions.teamPaymentCurrency;
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                selectedPlan: this.options.itemOptions.selectedPlan,
                teamPaymentCurrency: this.options.itemOptions.teamPaymentCurrency
            });
        },
    });

    return VMembershiptPlanList;

});

